// @flow
import { formatPrice } from 'utils/currencyUtils';

import type { Localizable, Localized } from './locale';
import { type Locale, localizable, localize } from './locale';

export opaque type RawMoney: number = number;

export function rawMoney(n: number): RawMoney {
  return n;
}

export type Money = Localizable<RawMoney>;

export function money(currency: Locale, n: number): Money {
  return localizable(currency, n);
}

export opaque type FormattedMoney: string = Localized<string>;

export function formatMoney(fm: Money): FormattedMoney {
  return localize(fm, (locale, number) => {
    // If the price is a round number, leave the decimals out
    if (Number.isInteger(number)) {
      return formatPrice(number, { precision: 0, locale: locale });
    }
    // Otherwise render with locale specific precision
    return formatPrice(number, { locale: locale });
  });
}
